import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {LOCALE_DATA} from "./helpers/constants";

Vue.use(VueI18n)

export default new VueI18n({
  locale: LOCALE_DATA.current || 'en',
  fallbackLocale: LOCALE_DATA.default || 'en',
  messages: {
    en: require('./locales/en.json'),
    fr: require('./locales/fr.json'),
  }
})
